'use strict';

angular.module('app').factory('authHttpResponseInterceptor', function ($q, $location, $rootScope) {
  return {
    request: function (config) {
      if (localStorage.getItem('token') && config.url.indexOf('/api/v2/') !== -1) {
        config.headers.Authorization = 'JWT ' + localStorage.getItem('token');
      }

      return config;
    },
    response: function (response) {
      if (response.status === 401) {
        console.debug('Response 401');
      }

      return response || $q.when(response);
    },
    responseError: function (rejection) {
      if (rejection.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        $location.path('/login/');
        $rootScope.user = null;
      }
      return $q.reject(rejection);
    },
  };
});
